/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loginerrorgeneric2Inputs */

const en_loginerrorgeneric2 = /** @type {(inputs: Loginerrorgeneric2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't send the link. Please try again.`)
};

const pt_loginerrorgeneric2 = /** @type {(inputs: Loginerrorgeneric2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar o link. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "We couldn't send the link. Please try again." |
*
* @param {Loginerrorgeneric2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const loginerrorgeneric2 = /** @type {((inputs?: Loginerrorgeneric2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loginerrorgeneric2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loginerrorgeneric2(inputs)
	return pt_loginerrorgeneric2(inputs)
});
export { loginerrorgeneric2 as "loginErrorGeneric" }